import { createContext, useContext } from "react";

// Shares a single window-scroll MotionValue (created once in Hero.jsx) across
// every SectionBackground instance, avoiding 8 duplicate scroll listeners.
export const ScrollYContext = createContext(null);
export const useSharedScrollY = () => useContext(ScrollYContext);
